module.exports = __webpack_public_path__ + "c9be9b07013ce770b4ded96eb69fbfbe.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/sleeping-6.png
// module id = 2267
// module chunks = 0